export const MAX_CACHE_SIZE = 1000;
export const CACHE_CLEANUP_INTERVAL = 60000; // 1 minute

export const cache = new Map<string, { 
	since: number; 
	value: unknown; 
	ready: boolean; 
	fetching: boolean; 
	ttl?: number;
}>();


setInterval(() => {
	const now = Date.now();
	for (const [key, entry] of cache.entries()) {
		if (entry.ttl && now - entry.since > entry.ttl) {
			cache.delete(key);
		}
	}

	if (cache.size > MAX_CACHE_SIZE) {
		const entries = Array.from(cache.entries());
		entries.sort((a, b) => a[1].since - b[1].since);
		const toDelete = entries.slice(0, cache.size - MAX_CACHE_SIZE);
		for (const [key] of toDelete) {
			cache.delete(key);
		}
	}
}, CACHE_CLEANUP_INTERVAL);
